import { render, staticRenderFns } from "./AffTable.vue?vue&type=template&id=d6f211fc"
import script from "./AffTable.vue?vue&type=script&lang=ts"
export * from "./AffTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports